import style from "./Footer.module.css";
import logo from "../../assets/images/logo.png";
import qrimg from "../../assets/images/qrcode.png";
import qrimg2 from "../../assets/images/qrcode2.png";
import { Link } from "react-router-dom";
export default function Main() {
  return (
    <>
      <div className={style.footer1}>
        <div className={style.footer1c}>
          <div className={style.leftbox}>
            <img src={logo} />
            <h3>温州市金茂担保有限公司</h3>
            <div>
              <Link to="/">首页</Link>
              <Link to="/about">关于我们 </Link>
              <Link to="/recommend">核心业务 </Link>
              <Link to="/company">公司动态 </Link>
              <Link to="/industry">行业资讯 </Link>

              <Link to="/contact">联系我们</Link>
            </div>
          </div>

          <div className={style.rightbox}>
            <div className={style.qrbox}>
              <img src={qrimg2} style={{ width: "150px" }} />
              <p>扫码注册会员</p>
            </div>
            <div className={style.qrbox} style={{ marginRight: "10px" }}>
              <img src={qrimg} style={{ width: "150px" }} />
              <p>扫码关注我们</p>
            </div>
            <p>服务热线电话</p>
            <p className={style.gold}>0577-88927182</p>
            <p className={style.gold}>13616621994</p>
            <p>金茂担保真诚欢迎您来电咨询</p>
          </div>
        </div>
      </div>
      <div className={style.footer2}>
        <div className={style.footer2c}>
          Copyright温州市金茂融资担保有公司版权所有
          {/* <a>浙ICP备2021026792号</a> */}
          <a href="https://beian.miit.gov.cn">浙ICP备15006688号-2</a>
          <span>浙公网安备3030302000080</span>
        </div>
      </div>
    </>
  );
}
